import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, NEVER, timer, of } from 'rxjs';
import { ConnectionStateService } from '../services/connection-state.service';
import { CustomToastersService } from '../services';
import { mergeMap, delay, delayWhen, take } from 'rxjs/operators';
import { PageStateService } from '../services/page-state.service';

@Injectable()
export class ConnectionStateInterceptor implements HttpInterceptor {
  constructor(
    private readonly connectionStateService: ConnectionStateService,
    private readonly pageStateService: PageStateService,
    private readonly customToastersService: CustomToastersService
  ) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.connectionStateService.online ? next.handle(req) : this.handleOfflineState(req, next);
  }

  private handleOfflineState(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.customToastersService.customInfo('Connection broken. Waiting for restore', 'Offline');

    return this.connectionStateService.connectionRestored
      .asObservable()
      .pipe(take(1))
      .pipe(delay(1000))
      .pipe(delayWhen(() => (this.pageStateService.isRefreshing ? timer(5000) : of(undefined))))
      .pipe(mergeMap(() => (this.pageStateService.isRefreshing ? NEVER : next.handle(req))));
  }
}
